<template>
  <div class="px-2 py-12 sm:px-8 mx-auto max-w-screen-xl">
    <h1 class="page-title">Settings</h1>

    <div class="mt-6 max-w-screen-2xl w-full">
      <div class="grid grid-cols-2 gap-6 w-full">
        <div class="col-span-2 lg:col-span-1">
          <form @submit.prevent="onUpdateSettings">
            <div class="shadow-xl rounded-xl bg-white dark:bg-gray-800 text-normal p-6">
              <div class="flex items-center justify-between pb-4 mb-4 border-b-2 border-gray-300">
                <h3 class="page-subtitle">System</h3>
              </div>
              <div class="flex flex-col gap-2">
                <div>
                  <label class="input-label">Theme</label>
                </div>
                <div class="flex gap-6">
                  <div class="flex gap-2 items-center">
                    <input id="theme-light" v-model="form.theme" type="radio" value="light" class="" />
                    <label for="theme-light">Light</label>
                  </div>
                  <div class="flex gap-2 items-center">
                    <input id="theme-dark" v-model="form.theme" type="radio" value="dark" class="" />
                    <label for="theme-dark">Dark</label>
                  </div>
                  <div class="flex gap-2 items-center">
                    <input id="theme-system" v-model="form.theme" type="radio" value="system" class="" />
                    <label for="theme-system">System</label>
                  </div>
                </div>
              </div>
            </div>

            <div class="shadow-xl rounded-xl bg-white dark:bg-gray-800 text-normal p-6 mt-8">
              <div class="flex items-center justify-between pb-4 mb-4 border-b-2 border-gray-300">
                <h3 class="page-subtitle">Email notification</h3>
              </div>
              <div class="flex flex-col gap-2">
                <div class="flex flex items-center gap-2">
                  <input id="email-magazine" v-model="form.email_magazine" type="checkbox" class="" />
                  <label for="email-magazine">Magazine emails</label>
                </div>
              </div>
            </div>

            <div class="mt-8 flex justify-center">
              <button type="submit" class="btn btn--primary">
                <i class="fa-solid fa-floppy-disk"></i>
                <span>Save settings</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { reactive } from 'vue'
  import { useAuth } from '$/composables/useAuth'
  import { useNotify } from '$/composables/useNotify'

  const { sessionStore } = useAuth()
  const { pushNotify, pushError } = useNotify()

  const form = reactive({
    theme: sessionStore.user.user_setting.theme,
    email_magazine: sessionStore.user.user_setting.email_magazine,
  })

  const onUpdateSettings = function () {
    sessionStore
      .updateSettings({ user_setting_form: form }, {})
      .then(() => {
        if (form.theme === 'dark') {
          document.documentElement.classList.add('dark')
          localStorage.setItem('theme', 'dark')
        } else if (form.theme === 'light') {
          document.documentElement.classList.remove('dark')
          localStorage.setItem('theme', 'light')
        } else {
          const systemPrefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
          if (systemPrefersDark) {
            document.documentElement.classList.add('dark')
            localStorage.setItem('theme', 'system')
          } else {
            document.documentElement.classList.remove('dark')
            localStorage.setItem('theme', 'system')
          }
        }
        pushNotify('Settings saved successfully!')
      })
      .catch((err) => {
        const error = err?.response?.data?.errors?.full_messages?.join('\n') || err?.message
        pushError(error)
      })
  }
</script>
